
const thermalData = [
    {name:'Price',condition:[
        {name:'$600 - $800',value:'600-800',includesData:['HS219']},
        {name:'$800 - $1000',value:'800-1000',includesData:['HS225']},
        {name:'$1000 - $1500',value:'1000-1500',includesData:['HS325','TNC225R']},
        {name:'$1500 - $2500',value:'1500-2500',includesData:['HS635','TNC335R','HS335']},
        {name:'$2500 and more',value:'2500',includesData:['TNC635R']}
    ]},
    {
        name:'Category',
        condition:[
            {name:'ThermNight',value:'ThermNight',includesData:['TNC335R','TNC225R','TNC635R']},
            {name:'Hydra',value:'Hydra',includesData:['HS225','HS325','HS635','HS219','HS335']}
        ]
    },
    {
        name:'Thermal Sensor Resolution',
        condition:[
            {name:'256x192 pixels',value:'256x192',includesData:['HS225','TNC225R','HS219']},
            {name:'384x288 pixels',value:'384x288',includesData:['HS325','TNC335R','HS335']}, 
            {name:'640x512 pixels',value:'640x512',includesData:['HS635','TNC635R']}
        ]
    },
    {
        name:'Display Resolution',
        condition:[
            {name:'1024x768 pixels',value:'1024x768',includesData:['HS225','HS325','HS635','TNC225R','HS219','HS335']},
            {name:'1920x1080 pixels',value:'1920x1080',includesData:['TNC335R','TNC635R']}
        ]
    },
    {
        name:'Magnification',
        condition:[
            {name:'1.5-6x',value:'1.5-6x',includesData:['HS635','TNC635R']},
            {name:'2-8x',value:'2-8x',includesData:['HS325']},
            {name:'2.5-10x',value:'2.5-10x',includesData:['TNC335R']},
            {name:'3-12x',value:'3-12x',includesData:['HS225','TNC225R','HS219','HS335']}
        ]
    },
    {
        name:'NETD Rating',
        condition:[
            {name:'≤18mk @25℃',value:'≤18mk',includesData:['HS635','HS325','TNC635R','TNC335R','HS335']},
            {name:'≤25mk @25℃',value:'≤25mk',includesData:['HS225','TNC225R','HS219']}
        ]
    },
    {
        name:'Objective Lens Focal Length',
        condition:[
            {name:'25mm',value:'25mm',includesData:['HS225','HS325','TNC225R','HS219']},
            {name:'35mm',value:'35mm',includesData:['HS635','TNC635R','TNC335R','HS335']}
        ]
    },
    {
        name:'Range Finder',
        condition:[
            {name:'Yes',value:'Yes',includesData:['TNC635R','TNC335R','TNC225R']},
            {name:'No',value:'No',includesData:['HS225','HS325','HS635','HS219','HS335']}
        ]
    },
    {
        name:'Operating Time',
        condition:[
            {name:'4-5h',value:'4-5h',includesData:['TNC635R','TNC335R','HS225','HS335']},
            {name:'5.5-6h',value:'5.5-6h',includesData:['HS635','HS325','TNC225R','HS219']}
        ]
    }
]
const nightVersion = [
    {name:'Price',condition:[
        {name:'$200 - $400',value:'200-400',includesData:['ZHD312','ZHD520']},
        {name:'$400 - $600',value:'400-600',includesData:['ZHD312-V2','ZHD520-V2']},
        {name:'$600 - $800',value:'600-800',includesData:['ZHD312R','ZHD520R','ZHD312R-V2','ZHD520R-V2']}
    ]},
    {
        name:'Category',
        condition:[
            {name:'ZULUS HD',value:'ZULUS-V1',includesData:['ZHD312R','ZHD520R','ZHD312','ZHD520']},
            {name:'ZULUS HD V2',value:'ZULUS-V2',includesData:['ZHD312R-V2','ZHD520R-V2','ZHD312-V2','ZHD520-V2']}
        ]
    },
    {
        name:'Magnification',
        condition:[
            {name:'3-12x',value:'3-12x',includesData:['ZHD312','ZHD312R','ZHD312-V2','ZHD312R-V2']},
            {name:'5-20x',value:'5-20x',includesData:['ZHD520R','ZHD520','ZHD520R-V2','ZHD520-V2']}
        ]
    },
    {
        name:'Range Finder',
        condition:[
            {name:'Yes',value:'Yes',includesData:['ZHD312R','ZHD312R-V2','ZHD520R','ZHD520R-V2']},
            {name:'No',value:'No',includesData:['ZHD312','ZHD312-V2','ZHD520','ZHD520-V2']}
        ]
    },
    {
        name:'Operating Time',
        condition:[
            {name:'8h',value:'8h',includesData:['ZHD312','ZHD312R','ZHD520R','ZHD520']},
            {name:'10h',value:'10h',includesData:['ZHD312-V2','ZHD312R-V2','ZHD520R-V2','ZHD520-V2']}
        ]
    },
    {
        name:'Eye Relief',
        condition:[
            {name:'45mm',value:'45mm',includesData:['ZHD312','ZHD312R','ZHD520R','ZHD520']},
            {name:'65mm',value:'65mm',includesData:['ZHD312-V2','ZHD312R-V2','ZHD520R-V2','ZHD520-V2']}
        ]
    },
    {
        name:'IR Wavelength',
        condition:[
            {name:'850nm',value:'850nm',includesData:['ZHD312','ZHD520']},
            {name:'6850/940nm',value:'850/940nm',includesData:['ZHD312R','ZHD520R','ZHD312-V2','ZHD312R-V2','ZHD520R-V2','ZHD520-V2']}
        ]
    }
]

function accessoriesData(productData){
        const matchIDs520312 = ['9102892466411','9052329705707','8947074203883','8724916044011','8861432873195','8642495217899','9001991569643','8868469604587','8867215671531','9002048913643','9002047045867']
        const matchIDsZulusV1 = ['9102892466411','9052329705707','8947074334955','8724916044011','8861432873195','8642495217899','9001991569643','8868469604587','8867215671531','9002048913643','9002047045867','8741746180331','8724690338027']
        const matchIDsZulusV2 = ['9102892466411','9052329705707','8947077841131','8809061089515','8861432873195','8642495217899','9001991569643','8741746180331','8855353721067','9002048913643','9002047045867']
        const matchIDsHydra = ['9102892466411','9052329705707','8947087278315','8724916044011','8861432873195','8642495217899','8868470620395','8868470161643','8867215671531']
        const matchIDsTNC225R = ['9102892466411','9052329705707','8947083149547','8724916044011','8861432873195','8741746180331','8724690338027','8642495217899','8868470620395','8868469604587','8867215671531']
        const matchIDsThermal = ['9102892466411','9052329705707','8947094782187','8809061089515','8861432873195','8642495217899','8868470620395','8868470161643','8855338975467','8867215671531','8855353721067']
        const matchIDsHydraLRF = ['9102892466411','9052329705707','8947087278315','8724916044011','8861432873195','8642495217899','8868470620395','8868470161643']
        const match650650R = ['9102892466411','9052329705707','8724916044011','8861432873195','8642495217899','8868470161643','8867215671531']
        const matchNVMDC200 = ['8724916044011','9102892466411','9116021489899']

        const Strarr= ['T-Shirt','Mesh-Back','Medallion Patch']
        const filterByAny = (items, keywords) => {
                const keys = (keywords || []).map(k => String(k).trim()).filter(Boolean).map(k => k.toLowerCase());
                if (!keys.length) return [];
                return items.filter(it => {
                    const t = String(it.title || '').toLowerCase();
                    return keys.some(k => t.includes(k));
                });
            };
        const data = [
            {
                name:'Price',
                condition:[
                    {name:'$0 - $9.99',value:'0-9.99',includesData: (productData.filter( obj => Number(obj.variants[0].price)<=9.99)).map(o => o.id) },
                    {name:'$10 - $49.99',value:'10-49.99',includesData: (productData.filter( obj => Number(obj.variants[0].price)>=10 && Number(obj.variants[0].price)<=49.99) ).map(o => o.id) },
                    {name:'$50 - $99.99',value:'50-99.99',includesData: (productData.filter( obj => Number(obj.variants[0].price)>=50 && Number(obj.variants[0].price)<=99.99) ).map(o => o.id) },
                    {name:'$100 and more',value:'100',includesData: (productData.filter( obj => Number(obj.variants[0].price)>=100) ).map(o => o.id) },
                ]
            },
            {
                name:'Category',
                condition:[
                    {name:'Bundle',value:'Bundle',includesData: (productData.filter( obj => obj.title.includes('Bundle') )).map(o => o.id) },
                    {name:'Battery',value:'Battery',includesData: (productData.filter( obj => obj.title.includes('Battery') )).map(o => o.id) },
                    {name:'Mount',value:'Mount',includesData: (productData.filter( obj => obj.title.includes('Mount') )).map(o => o.id) },
                    {name:'IR Module',value:'IRModule',includesData: (productData.filter( obj => obj.title.includes('IR Module') )).map(o => o.id) },
                    {name:'IR Delete Cap',value:'IRDeleteCap',includesData: (productData.filter( obj => obj.title.includes('IR Delete Cap') )).map(o => o.id) },
                    {name:'Eye Cup',value:'EyeCup',includesData: (productData.filter( obj => obj.title.includes('Eye Cup') )).map(o => o.id) },
                    {name:'Flip Up Cover',value:'FlipUpCover',includesData: (productData.filter( obj => obj.title.includes('Flip Up Cover') )).map(o => o.id)},
                    {name:'Throw Lever',value:'ThrowLever',includesData: (productData.filter( obj => obj.title.includes('Throw Lever') )).map(o => o.id)},
                    {name:'USB Side Cap',value:'USBSideCap',includesData: (productData.filter( obj => obj.title.includes('USB Side Cap') )).map(o => o.id)},
                    {name:'Wrap',value:'Wrap',includesData: (productData.filter( obj => obj.title.includes('Wrap') )).map(o => o.id)},
                    {name:'Apparel',value:'Apparel',includesData: (filterByAny(productData,Strarr)).map(o => o.id)}
                ]
            },
            {
                name:'Compatible with',
                condition:[
                    {name:'NVMD-C200',value:'NVMD-C200',includesData: (productData.filter( obj => matchNVMDC200.includes(obj.id.toString())) ).map(o => o.id)  },
                    {name:'ZHD312',value:'ZHD312',includesData: (productData.filter( obj => matchIDs520312.includes(obj.id.toString())) ).map(o => o.id)  },
                    {name:'ZHD520',value:'ZHD520',includesData: (productData.filter( obj => matchIDs520312.includes(obj.id.toString())) ).map(o => o.id) },
                    {name:'ZHD312R',value:'ZHD312R',includesData: (productData.filter( obj => matchIDsZulusV1.includes(obj.id.toString())) ).map(o => o.id) },
                    {name:'ZHD520R',value:'ZHD520R',includesData: (productData.filter( obj => matchIDsZulusV1.includes(obj.id.toString())) ).map(o => o.id) },
                    {name:'ZHD312-V2',value:'ZHD312-V2',includesData: (productData.filter( obj => matchIDsZulusV2.includes(obj.id.toString())) ).map(o => o.id)},
                    {name:'ZHD520-V2',value:'ZHD520-V2',includesData: (productData.filter( obj => matchIDsZulusV2.includes(obj.id.toString())) ).map(o => o.id)},
                    {name:'ZHD312R-V2',value:'ZHD312R-V2',includesData: (productData.filter( obj => matchIDsZulusV2.includes(obj.id.toString())) ).map(o => o.id)},
                    {name:'ZHD520R-V2',value:'ZHD520R-V2',includesData: (productData.filter( obj => matchIDsZulusV2.includes(obj.id.toString())) ).map(o => o.id)},
                    {name:'HS219',value:'HS219',includesData: (productData.filter( obj => matchIDsHydra.includes(obj.id.toString())) ).map(o => o.id)},
                    {name:'HS225',value:'HS225',includesData: (productData.filter( obj => matchIDsHydra.includes(obj.id.toString())) ).map(o => o.id)},
                    {name:'HS325',value:'HS325',includesData: (productData.filter( obj => matchIDsHydra.includes(obj.id.toString())) ).map(o => o.id)},
                    {name:'HS335',value:'HS335',includesData: (productData.filter( obj => matchIDsHydra.includes(obj.id.toString())) ).map(o => o.id)},
                    {name:'HS635',value:'HS635',includesData: (productData.filter( obj => matchIDsHydra.includes(obj.id.toString())) ).map(o => o.id)},
                    {name:'HS650',value:'HS650',includesData: (productData.filter( obj => match650650R.includes(obj.id.toString())) ).map(o => o.id)},
                    {name:'HS225R',value:'HS225R',includesData: (productData.filter( obj => matchIDsHydraLRF.includes(obj.id.toString())) ).map(o => o.id)},
                    {name:'HS335R',value:'HS335R',includesData: (productData.filter( obj => matchIDsHydraLRF.includes(obj.id.toString())) ).map(o => o.id)},
                    {name:'HS635R',value:'HS635R',includesData: (productData.filter( obj => matchIDsHydraLRF.includes(obj.id.toString())) ).map(o => o.id)},
                    {name:'HS650R',value:'HS650R',includesData: (productData.filter( obj => match650650R.includes(obj.id.toString())) ).map(o => o.id)},
                    {name:'TNC225R',value:'TNC225R',includesData: (productData.filter( obj => matchIDsTNC225R.includes(obj.id.toString())) ).map(o => o.id)},
                    {name:'TNC335R',value:'TNC335R',includesData: (productData.filter( obj => matchIDsThermal.includes(obj.id.toString())) ).map(o => o.id)},
                    {name:'TNC635R',value:'TNC635R',includesData: (productData.filter( obj => matchIDsThermal.includes(obj.id.toString())) ).map(o => o.id)}
                ]
            }
        ]
    return data
}
function allProcudtc(productData){
    const data = [
    {
        name:'Price',
            condition:[
                {name:'$0 - $200',value:'0-200',includesData: (productData.filter( obj => Number(obj.variants[0].price)<200 ) ).map(o => o.id)},
                {name:'$200 - $400',value:'200-400',includesData: (productData.filter( obj => Number(obj.variants[0].price)>=200 && Number(obj.variants[0].price)<400 ) ).map(o => o.id)},
                {name:'$400 - $600',value:'400-600',includesData: (productData.filter( obj => Number(obj.variants[0].price)>=400 && Number(obj.variants[0].price)<600 ) ).map(o => o.id)},
                {name:'$600 - $800',value:'600-800',includesData: (productData.filter( obj => Number(obj.variants[0].price)>=600 && Number(obj.variants[0].price)<800 ) ).map(o => o.id)},
                {name:'$800 - $1000',value:'800-1000',includesData: (productData.filter( obj => Number(obj.variants[0].price)>=800 && Number(obj.variants[0].price)<1000 ) ).map(o => o.id)},
                {name:'$1000 - $1500',value:'1000-1500',includesData: (productData.filter( obj => Number(obj.variants[0].price)>=1000 && Number(obj.variants[0].price)<1500 ) ).map(o => o.id)},
                {name:'$1500 - $2500',value:'1500-2500',includesData: (productData.filter( obj => Number(obj.variants[0].price)>=1500 && Number(obj.variants[0].price)<2500 ) ).map(o => o.id)},
                {name:'$2500 and more',value:'2500',includesData: (productData.filter( obj => Number(obj.variants[0].price)>=2500 ) ).map(o => o.id)}
            ]
        },
        {
            name:'Category',
            condition:[
                {name:'Night Vison Scope',value:'NightVison',includesData: (productData.filter( obj => obj.product_type == 'ZULUS') ).map(o => o.id)},
                {name:'Thermal Scope',value:'Thermal',includesData: (productData.filter( obj => ['ThermNight','Hydra'].includes(obj.product_type) ) ).map(o => o.id)},
                {name:'Optics',value:'Optics',includesData: (productData.filter( obj => obj.product_type == 'Optics') ).map(o => o.id)},
                {name:'Accessories',value:'Accessories',includesData: (productData.filter( obj => obj.product_type == 'Accessories')||obj.title.includes('Accessories') ).map(o => o.id)}
            ]
        }
    ]
    return data
}

var publicCondition
function getModelData(param){
    switch (currentModel) {
        case 'thermal':
            publicCondition = thermalData
            break;
        case 'night-vision':
            publicCondition = nightVersion
            break;
        case 'all-products':
            publicCondition = allProcudtc(param)
            break;
        case 'accessories':
            publicCondition = accessoriesData(param)
            break;
    }
    return publicCondition
}

function filterCondition(data,publicFilterList,customCollectionData){
        switch (currentModel) {
        case 'thermal':
                    data.map( condition => {
                        switch (condition) {
                        case 'ThermNight':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['TNC635R','TNC335R','TNC225R'].includes(obj.variants[0].sku) )]
                        break;
                        case 'Hydra':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['HS225','HS325','HS635'].includes(obj.variants[0].sku) )] 
                        break;
                        case '256x192':
                            console.log('')
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['TNC225R','HS225'].includes(obj.variants[0].sku) )] 
                        break;
                        case '384x288':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['TNC335R','HS325'].includes(obj.variants[0].sku) )] 
                            break;
                        case '640x512':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['TNC635R','HS635'].includes(obj.variants[0].sku) )] 
                        break;
                        case '800-1000':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => Number(obj.variants[0].price)>=800 && Number(obj.variants[0].price)<1000 )] 
                        break;
                        case '1000-1500':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => Number(obj.variants[0].price)>=1000 && Number(obj.variants[0].price)<1500 )] 
                            break;
                        case '1500-2500':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => Number(obj.variants[0].price)>=1500 && Number(obj.variants[0].price)<2500 )] 
                        break;
                        case '2500':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => Number(obj.variants[0].price)>=2500 )] 
                        break;
                        case '1024x768':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['TNC225R','HS225','HS325','HS635'].includes(obj.variants[0].sku) )] 
                        break;
                        case '1920x1080':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['TNC335R','TNC635R'].includes(obj.variants[0].sku) )] 
                            break;
                        case '1.5-6x':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['TNC635R','HS635'].includes(obj.variants[0].sku) )] 
                        break;
                        case '2-8x':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['HS325'].includes(obj.variants[0].sku) )] 
                        break;
                        case '2.5-10x':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['TNC335R'].includes(obj.variants[0].sku) )] 
                        break;
                        case '3-12x':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['TNC225R','HS225'].includes(obj.variants[0].sku) )] 
                        break;
                        case '≤18mk':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['TNC635R','TNC335R','HS325','HS635'].includes(obj.variants[0].sku) )] 
                        break;
                        case '≤25mk':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['TNC225R','HS225'].includes(obj.variants[0].sku) )] 
                        break;
                        case '25mm':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['TNC225R','HS225','HS325'].includes(obj.variants[0].sku) )] 
                        break;
                        case '35mm':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['TNC335R','TNC635R','HS635'].includes(obj.variants[0].sku) )] 
                        break;
                        case 'Yes':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['TNC225R','TNC335R','TNC635R'].includes(obj.variants[0].sku) )] 
                        break;
                        case 'No':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['HS225','HS325','HS635'].includes(obj.variants[0].sku) )] 
                        break;
                        case '4-5h':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['HS225','TNC335R','TNC635R'].includes(obj.variants[0].sku) )] 
                        break;
                        case '5.5-6h':
                            publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['TNC225R','HS325','HS635'].includes(obj.variants[0].sku) )] 
                        break;
                    }
                })
            break;
        case 'night-vision':
                    data.map( condition => {
                        switch (condition) {
                            case 'ZULUS-V1':
                                publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['ZHD312R','ZHD312','ZHD520R','ZHD520'].includes(obj.variants[0].sku) )]
                            break;
                            case 'ZULUS-V2':
                                publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['ZHD312R-V2','ZHD312-V2','ZHD520R-V2','ZHD520-V2'].includes(obj.variants[0].sku) )] 
                            break;
                            case '200-400':
                                publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => Number(obj.variants[0].price)>=200 && Number(obj.variants[0].price)<400 )] 
                            break;
                            case '400-600':
                                publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => Number(obj.variants[0].price)>=400 && Number(obj.variants[0].price)<600 )] 
                                break;
                            case '600-800':
                                publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => Number(obj.variants[0].price)>=600 && Number(obj.variants[0].price)<=800 )] 
                            break;
                            case '3-12x':
                                publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['ZHD312R','ZHD312','ZHD312R-V2','ZHD312-V2'].includes(obj.variants[0].sku) )] 
                            break;
                            case '5-20x':
                                publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['ZHD520R','ZHD520','ZHD520R-V2','ZHD520-V2'].includes(obj.variants[0].sku) )] 
                            break;
                            case '850nm':
                                publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['ZHD312','ZHD520'].includes(obj.variants[0].sku) )] 
                            break;
                            case '850/940nm':
                                publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['ZHD312R','ZHD520R','ZHD312R-V2','ZHD312-V2','ZHD520R-V2','ZHD520-V2'].includes(obj.variants[0].sku) )] 
                            break;
                            case '45mm':
                                publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['ZHD312R','ZHD312','ZHD520R','ZHD520'].includes(obj.variants[0].sku) )] 
                            break;
                            case '65mm':
                                publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['ZHD312R-V2','ZHD312-V2','ZHD520R-V2','ZHD520-V2'].includes(obj.variants[0].sku) )] 
                            break;
                            case 'Yes':
                                publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['ZHD312R','ZHD520R','ZHD312R-V2','ZHD520R-V2'].includes(obj.variants[0].sku) )] 
                            break;
                            case 'No':
                                publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['ZHD312','ZHD520','ZHD312-V2','ZHD520-V2'].includes(obj.variants[0].sku) )] 
                            break;
                            case '8h':
                                publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['ZHD312R','ZHD312','ZHD520R','ZHD520'].includes(obj.variants[0].sku) )] 
                            break;
                            case '10h':
                                publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['ZHD312R-V2','ZHD312-V2','ZHD520R-V2','ZHD520-V2'].includes(obj.variants[0].sku) )] 
                            break;
                        }
                })
            break;
        case 'all-products':
            data.map( condition => {
                switch(condition){
                    case 'NightVison':
                     publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => obj.product_type == "ZULUS" )]
                    break;
                    case 'Thermal':
                     publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ["Hydra","ThermNight"].includes(obj.product_type) )]
                    break;
                    case 'Optics':
                     publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ["Optics"].includes(obj.product_type) )]
                    break;
                    case 'Accessories':
                     publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ["Accessories"].includes(obj.product_type)||obj.title.includes('Accessories'))]
                    break;
                    case '0-200':
                     publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => Number(obj.variants[0].price)<=200  )]
                    break;
                    case '200-400':
                     publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => Number(obj.variants[0].price)>=200 && Number(obj.variants[0].price)<400  )]
                    break;
                    case '400-600':
                     publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => Number(obj.variants[0].price)>=400 && Number(obj.variants[0].price)<600  )]
                    break;
                    case '600-800':
                     publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => Number(obj.variants[0].price)>=600 && Number(obj.variants[0].price)<800  )]
                    break;
                    case '800-1000':
                     publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => Number(obj.variants[0].price)>=800 && Number(obj.variants[0].price)<1000  )]
                    break;
                    case '1000-1500':
                     publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => Number(obj.variants[0].price)>=1000 && Number(obj.variants[0].price)<1500  )]
                    break;
                    case '1500-2500':
                     publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => Number(obj.variants[0].price)>=1500 && Number(obj.variants[0].price)<2500  )]
                    break;
                    case '2500':
                     publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => Number(obj.variants[0].price)>=2500 )]
                    break;
                }
            })
            break;
        case 'accessories':
            data.map( condition => {
                switch(condition){
                    case '0-9.99':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => Number(obj.variants[0].price)<=9.99  )]
                        break;
                    case '10-49.99':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => Number(obj.variants[0].price)>=10 && Number(obj.variants[0].price)<=49.99  )]
                        break;
                    case '50-99.99':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => Number(obj.variants[0].price)>=50 && Number(obj.variants[0].price)<=99.99  )]
                        break;
                    case '100':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => Number(obj.variants[0].price)>=100  )]
                        break;
                    case 'Bundle':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => obj.title.includes('Bundle') )]
                        break;
                    case 'Battery':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => obj.title.includes('Battery') )]
                        break;
                    case 'Mount':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => obj.title.includes('Mount') )]
                    break;
                    case 'IRModule':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => obj.title.includes('IR Module') )]
                        break;
                    case 'IRDeleteCap':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => obj.title.includes('IR Delete Cap') )]
                        break;
                    case 'EyeCup':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => obj.title.includes('Eye Cup') )]
                        break;
                    case 'FlipUpCover':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => obj.title.includes('Flip Up Cover') )]
                        break;
                    case 'ThrowLever':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => obj.title.includes('Throw Lever') )]
                        break;
                    case 'USBSideCap':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => obj.title.includes('USB Side Cap') )]
                        break;                    
                    case 'Wrap':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => obj.title.includes('Wrap') )]
                        break;
                    case 'Apparel':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => obj.title.includes('Apparel') )]
                        break;
                    case 'ZHD312':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => ['Accessories Bundle for ZULUS V1','18650 Flat Top Battery',
                            'ADM QD American Defense Manufacturing AD-170-S – Compatible with ThermNight, Hydra and ZULUS HD','Digital Night Vision Scope Mounts',
                            'Flip Up Cover for ZULUS HD & ZULUS HD V2','Eye Cup for ZULUS HD V1 and TNC225R','Nocorium Multicam Wrap for Hydra, ThermNight and ZULUS HD',
                            'Digital Scope Throw Lever for ZULUS HD & ZULUS HD V2','USB Side Cap for ZULUS HD & ZULUS HD V2'
                        ].includes(obj.title) )]
                        break;
                    case 'ZHD520':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => [
                            'Accessories Bundle for ZULUS V1','18650 Flat Top Battery','ADM QD American Defense Manufacturing AD-170-S – Compatible with ThermNight, Hydra and ZULUS HD',
                            'Digital Night Vision Scope Mounts','Flip Up Cover for ZULUS HD & ZULUS HD V2','Eye Cup for ZULUS HD V1 and TNC225R','Nocorium Multicam Wrap for Hydra, ThermNight and ZULUS HD',
                            'Digital Scope Throw Lever for ZULUS HD & ZULUS HD V2','USB Side Cap for ZULUS HD & ZULUS HD V2'
                        ].includes(obj.title) )]
                        break;
                    case 'ZHD312R':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => [
                           'Accessories Bundle for ZHD520R & ZHD312R','18650 Flat Top Battery','ADM QD American Defense Manufacturing AD-170-S – Compatible with ThermNight, Hydra and ZULUS HD',
                           'Digital Night Vision Scope Mounts','Flip Up Cover for ZULUS HD & ZULUS HD V2','Eye Cup for ZULUS HD V1 and TNC225R','Nocorium Multicam Wrap for Hydra, ThermNight and ZULUS HD',
                           'Digital Scope Throw Lever for ZULUS HD & ZULUS HD V2','USB Side Cap for ZULUS HD & ZULUS HD V2','940nm IR Module IR940V-M21 for ZHD520R, ZHD312R and TNC225R','IR Delete Cap PLUG-M21 for ZHD520R, ZHD312R and TNC225R'
                        ].includes(obj.title) )]
                        break;
                    case 'ZHD520R':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => [
                           'Accessories Bundle for ZHD520R & ZHD312R','18650 Flat Top Battery','ADM QD American Defense Manufacturing AD-170-S – Compatible with ThermNight, Hydra and ZULUS HD',
                           'Digital Night Vision Scope Mounts','Flip Up Cover for ZULUS HD & ZULUS HD V2','Eye Cup for ZULUS HD V1 and TNC225R','Nocorium Multicam Wrap for Hydra, ThermNight and ZULUS HD',
                           'Digital Scope Throw Lever for ZULUS HD & ZULUS HD V2','USB Side Cap for ZULUS HD & ZULUS HD V2','940nm IR Module IR940V-M21 for ZHD520R, ZHD312R and TNC225R','IR Delete Cap PLUG-M21 for ZHD520R, ZHD312R and TNC225R'
                        ].includes(obj.title) )]
                        break;
                    case 'ZHD312-V2':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => [
                            'Accessories Bundle for ZULUS HD V2','21700 Flat Top Battery','ADM QD American Defense Manufacturing AD-170-S – Compatible with ThermNight, Hydra and ZULUS HD','Digital Night Vision Scope Mounts',
                            'Flip Up Cover for ZULUS HD & ZULUS HD V2','940nm IR Module IR940V-M24 for ZULUS HD V2, TNC335R and TNC635R','IR Delete Cap PLUG-M24 for ZULUS HD V2, TNC335R and TNC635R','Digital Scope Throw Lever for ZULUS HD & ZULUS HD V2',
                            'USB Side Cap for ZULUS HD & ZULUS HD V2'
                        ].includes(obj.title) )]
                        break;
                    case 'ZHD520-V2':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => [
                            'Accessories Bundle for ZULUS HD V2','21700 Flat Top Battery','ADM QD American Defense Manufacturing AD-170-S – Compatible with ThermNight, Hydra and ZULUS HD','Digital Night Vision Scope Mounts',
                            'Flip Up Cover for ZULUS HD & ZULUS HD V2','940nm IR Module IR940V-M24 for ZULUS HD V2, TNC335R and TNC635R','IR Delete Cap PLUG-M24 for ZULUS HD V2, TNC335R and TNC635R','Digital Scope Throw Lever for ZULUS HD & ZULUS HD V2',
                            'USB Side Cap for ZULUS HD & ZULUS HD V2'
                        ].includes(obj.title) )]
                        break;
                    case 'ZHD312R-V2':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => [
                            'Accessories Bundle for ZULUS HD V2','21700 Flat Top Battery','ADM QD American Defense Manufacturing AD-170-S – Compatible with ThermNight, Hydra and ZULUS HD','Digital Night Vision Scope Mounts',
                            'Flip Up Cover for ZULUS HD & ZULUS HD V2','940nm IR Module IR940V-M24 for ZULUS HD V2, TNC335R and TNC635R','IR Delete Cap PLUG-M24 for ZULUS HD V2, TNC335R and TNC635R','Digital Scope Throw Lever for ZULUS HD & ZULUS HD V2',
                            'USB Side Cap for ZULUS HD & ZULUS HD V2'
                        ].includes(obj.title) )]
                        break;
                    case 'ZHD520R-V2':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => [
                            'Accessories Bundle for ZULUS HD V2','21700 Flat Top Battery','ADM QD American Defense Manufacturing AD-170-S – Compatible with ThermNight, Hydra and ZULUS HD','Digital Night Vision Scope Mounts',
                            'Flip Up Cover for ZULUS HD & ZULUS HD V2','940nm IR Module IR940V-M24 for ZULUS HD V2, TNC335R and TNC635R','IR Delete Cap PLUG-M24 for ZULUS HD V2, TNC335R and TNC635R','Digital Scope Throw Lever for ZULUS HD & ZULUS HD V2',
                            'USB Side Cap for ZULUS HD & ZULUS HD V2'
                        ].includes(obj.title) )]
                        break;
                    case 'HS225':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => [
                            'Accessories Bundle for Hydra','18650 Flat Top Battery','ADM QD American Defense Manufacturing AD-170-S – Compatible with ThermNight, Hydra and ZULUS HD','Digital Night Vision Scope Mounts',
                            'Flip Up Cover for ThermNight and Hydra','Eye Cup for TNC335R, TNC635R and Hydra','Nocorium Multicam Wrap for Hydra, ThermNight and ZULUS HD'
                        ].includes(obj.title) )]
                        break;
                    case 'HS325':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => [
                            'Accessories Bundle for Hydra','18650 Flat Top Battery','ADM QD American Defense Manufacturing AD-170-S – Compatible with ThermNight, Hydra and ZULUS HD','Digital Night Vision Scope Mounts',
                            'Flip Up Cover for ThermNight and Hydra','Eye Cup for TNC335R, TNC635R and Hydra','Nocorium Multicam Wrap for Hydra, ThermNight and ZULUS HD'
                        ].includes(obj.title) )]
                        break;
                    case 'HS635':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => [
                            'Accessories Bundle for Hydra','18650 Flat Top Battery','ADM QD American Defense Manufacturing AD-170-S – Compatible with ThermNight, Hydra and ZULUS HD','Digital Night Vision Scope Mounts',
                            'Flip Up Cover for ThermNight and Hydra','Eye Cup for TNC335R, TNC635R and Hydra','Nocorium Multicam Wrap for Hydra, ThermNight and ZULUS HD'
                        ].includes(obj.title) )]
                        break;
                    case 'TNC225R':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => [
                            'Accessories Bundle for TNC225R','18650 Flat Top Battery','ADM QD American Defense Manufacturing AD-170-S – Compatible with ThermNight, Hydra and ZULUS HD','940nm IR Module IR940V-M21 for ZHD520R, ZHD312R and TNC225R',
                            'IR Delete Cap PLUG-M21 for ZHD520R, ZHD312R and TNC225R','Digital Night Vision Scope Mounts','Flip Up Cover for ThermNight and Hydra','Eye Cup for ZULUS HD V1 and TNC225R','Nocorium Multicam Wrap for Hydra, ThermNight and ZULUS HD'
                        ].includes(obj.title) )]
                        break;
                    case 'TNC335R':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => [
                            'Accessories Bundle for TNC335R & TNC635R','21700 Flat Top Battery','ADM QD American Defense Manufacturing AD-170-S – Compatible with ThermNight, Hydra and ZULUS HD','Digital Night Vision Scope Mounts',
                            'Flip Up Cover for ThermNight and Hydra','Eye Cup for TNC335R, TNC635R and Hydra','940nm IR Module IR940V-M24 for ZULUS HD V2, TNC335R and TNC635R','Nocorium Multicam Wrap for Hydra, ThermNight and ZULUS HD',
                            'IR Delete Cap PLUG-M24 for ZULUS HD V2, TNC335R and TNC635R'
                        ].includes(obj.title) )]
                        break;
                    case 'TNC635R':
                        publicFilterList = [...publicFilterList,...customCollectionData.filter( obj => [
                            'Accessories Bundle for TNC335R & TNC635R','21700 Flat Top Battery','ADM QD American Defense Manufacturing AD-170-S – Compatible with ThermNight, Hydra and ZULUS HD','Digital Night Vision Scope Mounts',
                            'Flip Up Cover for ThermNight and Hydra','Eye Cup for TNC335R, TNC635R and Hydra','940nm IR Module IR940V-M24 for ZULUS HD V2, TNC335R and TNC635R','Nocorium Multicam Wrap for Hydra, ThermNight and ZULUS HD',
                            'IR Delete Cap PLUG-M24 for ZULUS HD V2, TNC335R and TNC635R'
                        ].includes(obj.title) )]
                        break;

                }
            })
    }
    return publicFilterList
}